module.exports = __webpack_public_path__ + "static/media/nebula.b8492acc.jpg";